const initialState = {
    style: 'white', // style: white | transparent
    type: 'search', // type: search | title
    eventsLogo: false,
    oldLogo: false,
    title: null,
    subTitle: null,
    titleInfo: null,
    lastLocation: null,
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'HEADER:SET_HEADER_MODE': {
            // console.log('action.conf', action.conf);
            const {
                style = 'white',
                type = 'search',
                eventsLogo = false,
                disabled = false,
                title,
                lastLocation,
                showProLink,
                subTitle,
                titleInfo,
                subTitleInfo,
                ...rest
            } = action.conf;

            return {
                ...state,
                style,
                type,
                eventsLogo,
                disabled,
                title,
                lastLocation,
                showProLink,
                subTitle,
                titleInfo,
                subTitleInfo,
                ...rest,
            };
        }

        default:
            return state;
    }
}

export default app;
